import styled from "styled-components";
const circleSize = "6px";
export const ListItem = styled.li `
  display: table;
  font-size: ${({ theme, fontSize }) => fontSize === "p1"
    ? theme.fontTokens.font11[0]
    : theme.fontTokens.font12[0]};
  line-height: ${({ theme, fontSize }) => fontSize === "p1"
    ? theme.fontTokens.font11[1]
    : theme.fontTokens.font12[1]};
  counter-increment: list-counter;
  margin-top: ${({ listItemMarginTop }) => listItemMarginTop}px;

  ${({ ordered, listItemMarginLeft }) => {
    if (!ordered)
        return `
        padding-left: calc(${circleSize} + ${listItemMarginLeft}px);
        position: relative;
      `;
}}
  &::before {
    content: " ";
    ${({ ordered }) => (ordered ? "display: table-cell" : "")};

    padding-right: ${({ ordered, listItemMarginLeft }) => ordered ? `${listItemMarginLeft}px` : "0rem"};

    ${({ ordered, theme, fontSize }) => {
    if (!ordered)
        return `
        width: ${circleSize};
        box-sizing: border-box;
        left: 0;
        position: absolute;
        top: calc(${fontSize === "p1"
            ? theme.fontTokens.font11[1]
            : theme.fontTokens.font12[1]} / 2); 
        transform: translateY(-50%);
        `;
}}

    ${({ ordered, level, fontSize }) => {
    if (!ordered && level === "2")
        return ` 
      content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='6' width='6' viewBox='0 0 10 10' preserveAspectRatio='xMidYMid meet'><circle cx='50%' cy='50%' r='4' stroke='black' stroke-width='2'  fill='white' width='100%' height='100%'/>
      </svg>");
      top: ${fontSize === "p1" ? `0.563rem` : `0.5rem`};
        `;
    if (!ordered && level === "1")
        return `
      content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='6' width='6'  viewBox='0 0 10 10' preserveAspectRatio='xMidYMid meet'><circle cx='50%' cy='50%' r='4' fill='black' stroke='black' stroke-width='2' width='100%' height='100%'/>
      </svg>");
      top: ${fontSize === "p1" ? `0.563rem` : `0.5rem`};
        `;
}}

    ${({ ordered, level, fontSize }) => {
    if (!ordered && level === "3")
        return `
      content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='6' width='6' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid meet'><line x1='0' y1='0' x2='600' y2='0' stroke='black' stroke-width='60'  width='100%' height='100%'/></svg>");
      top: ${fontSize === "p1" ? `0.688rem` : `0.625rem`};
      `;
}}

    ${({ ordered, level }) => {
    if (ordered && level === "1") {
        return `
        content: counters(list-counter, ".") ".";
        `;
    }
    if (ordered && level !== "1") {
        return `
        content: counters(list-counter, ".");
      `;
    }
}}
  }
`;
ListItem.displayName = "ListItem";
